export const apiConstants = {
  dishes: '/dishes',
};
